import MiniMasonry from 'minimasonry';

function ImageGridInstance(element) {
  const masonry = new MiniMasonry({
    container: element,
    baseWidth: 270,
    gutter: 10,
  });

  const images = [...element.querySelectorAll('img')];

  // Trigger a masonry re-layout whenever a lazy-loaded img is loaded.
  images.length && images.forEach((img) => {
    img.addEventListener('load', () => {
      masonry.layout();
    });
  });
}

export function init() {
  const elements = document.querySelectorAll('[data-js-image-grid]');

  [...elements].forEach((element) => {
    new ImageGridInstance(element);
  });
}
